import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import posthog, { PostHogConfig } from 'posthog-js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const posthogConfig: Partial<PostHogConfig> = {
  session_recording: {
    maskAllInputs: false,
  },
  api_host: 'https://us.i.posthog.com',
  capture_pageview: false,
  autocapture: false,
};

if (environment.production) {
  enableProdMode();
  posthog.init('phc_bl7GljRXbLA5a3wZtmoTzUGJNnnBGJP7lm5tgsaLhEq', posthogConfig, 'main');
} else {
  posthog.init('phc_uWOzhE5Z5GXZ1DUjkqs3RxoijY8YlZ7FWNGFPQdGyuz', posthogConfig, 'main');
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
